import axios from './http'

// 获取某提投资者列表
export const GetMpList = query => {
    return axios.get("/mp/list", {params: query}).then(res => res.data)
};
// 删除媒体投资者关系
export const DelMpId = mpId => {
    return axios.delete(`/mp/${mpId}`).then(res => res.data)
};
